import React from 'react';
import Category from './Category';
import style from './index.scss';
export const GamesInPopup = ({ cid, games, className = '', categoryName, mostPlayedGame }) => (
    <div className={`${className} ${style.container}`}>
        <Category
            cid={cid}
            gameCodes={games}
            className={style.category}
            categoryName={categoryName}
            mostPlayedGame={mostPlayedGame}
        />
    </div>
);
export default GamesInPopup;
